import Widget from '../helpers/widget'

window.adaptis = window.adaptis || {
    "modules": {
        "Widget": Widget
    },
    "widgets": []
}
